import React, { useRef, useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './SimpleInput.module.scss';

const SimpleInput = (props) => {
  const { className, focus, ...inputProps } = props;
  const inputRef = useRef();

  useEffect(() => {
    if (focus) {
      inputRef.current.focus();
    }
  }, [focus]);

  return (
    <input
      {...inputProps}
      className={cn(styles.container, props.className)}
      ref={inputRef}
      data-testid={props['data-testid'] || 'simple-input'}
    />
  );
};

export default SimpleInput;

SimpleInput.defaultProps = {
  className: '',
  type: 'text',
  focus: true,
  value: '',
};

SimpleInput.propTypes = {
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  focus: PropTypes.bool,
};
